import React from 'react';
import PropTypes from 'prop-types';

function StepDot({ state }) {
  const base = {
    width: 22,
    height: 22,
    borderRadius: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 800,
    lineHeight: 1,
    flex: '0 0 auto',
  };

  if (state === 'done') {
    return (
      <div style={{ ...base, background: '#0B4BFF', color: '#fff' }}>
        ✓
      </div>
    );
  }

  if (state === 'active') {
    return (
      <div
        style={{
          ...base,
          background: '#fff',
          border: '3px solid #0B4BFF',
          color: '#0B4BFF',
        }}
      >
        {null}
      </div>
    );
  }

  return <div style={{ ...base, background: '#E6EAF2', color: '#7A8599' }} />;
}

StepDot.propTypes = {
  state: PropTypes.oneOf(['done', 'active', 'todo']).isRequired,
};

export default function StepProgress({ step }) {
  const s = Math.min(3, Math.max(1, Number(step) || 1));
  const steps = [
    { key: 'personal', label: '' },
    { key: 'form', label: '' },
    { key: 'success', label: '' },
  ];

  const getState = (i) => {
    // On the success, show all steps as completed (check icons).
    if (s === 3) return 'done';
    if (i < s) return 'done';
    if (i === s) return 'active';
    return 'todo';
  };
  
  return (
    <div className="mt-3 mb-3">
      <div className="d-flex align-items-center" style={{ gap: 10 }}>
        {steps.map((st, idx) => {
          const i = idx + 1;
          const state = getState(i);
          const lineColor = i < s ? '#0B4BFF' : '#E1E5EE';
          return (
            <React.Fragment key={st.key}>
              <div className="d-flex align-items-center" style={{ gap: 8 }}>
                <StepDot state={state} />
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: state === 'active' ? 800 : 600,
                    color: state === 'todo' ? '#7A8599' : '#111',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {st.label}
                </div>
              </div>
              {idx < steps.length - 1 ? (
                <div style={{ flex: 1, height: 2, background: lineColor, borderRadius: 999 }} />
              ) : null}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

StepProgress.propTypes = {
  step: PropTypes.number.isRequired,
};

